/**
 * Love Store Paris — Offres rotatives (72 h / créneau, Europe/Paris)
 */
(function () {
  'use strict';

  var SLOT_HOURS_DEFAULT = 72;
  var HTML_KEYS = {
    intro_html: true,
    products_html: true,
    subtitle_html: true,
    banner_subtitle: true
  };

  function readConfig() {
    var node = document.getElementById('lsp-rotating-offer-config');
    if (!node || !node.textContent) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function parseParisStart(value) {
    var raw = String(value || '').trim().replace(' ', 'T');
    if (!raw) raw = '2026-10-03T00:00:00';
    if (raw.indexOf('T') === -1) raw += 'T00:00:00';
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(raw)) raw += ':00';
    if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) return Date.parse(raw);

    var asUtc = Date.parse(raw + 'Z');
    if (isNaN(asUtc)) return Date.parse(raw);

    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    function tzOffsetMs(ms) {
      var parts = formatter.formatToParts(new Date(ms));
      var map = {};
      parts.forEach(function (part) {
        map[part.type] = part.value;
      });
      var hour = map.hour === '24' ? 0 : parseInt(map.hour, 10);
      var localAsUtc = Date.UTC(
        parseInt(map.year, 10),
        parseInt(map.month, 10) - 1,
        parseInt(map.day, 10),
        hour,
        parseInt(map.minute, 10),
        parseInt(map.second, 10)
      );
      return localAsUtc - ms;
    }

    return asUtc - tzOffsetMs(asUtc);
  }

  function computeSlot(config, nowMs) {
    var offers = config.offers || [];
    var count = offers.length || 3;
    var slotMs = (config.slotHours || SLOT_HOURS_DEFAULT) * 60 * 60 * 1000;
    var startMs = parseParisStart(config.start);
    if (isNaN(startMs)) startMs = Date.now();

    var now = nowMs || Date.now();
    var elapsed = now - startMs;
    var cycles = elapsed < 0 ? 0 : Math.floor(elapsed / slotMs);
    var slot = ((cycles % count) + count) % count;
    var slotEndMs = startMs + (cycles + 1) * slotMs;

    return {
      slot: slot,
      slotEndMs: slotEndMs,
      slotEndIso: new Date(slotEndMs).toISOString(),
      offer: offers[slot] || offers[0]
    };
  }

  function decodeEntities(value) {
    if (value == null) return value;
    var str = String(value);
    if (str.indexOf('&') === -1) return str;
    var textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  }

  function setText(el, value) {
    el.textContent = decodeEntities(value);
  }

  function setHidden(el, hide) {
    if (!el) return;
    if (hide) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function applyField(el, key, offer, slotEndIso) {
    if (key === 'countdown') {
      el.setAttribute('data-countdown-end', slotEndIso);
      return;
    }
    if (key === 'url' || key === 'href') {
      if (offer.url) {
        el.setAttribute('href', offer.url);
        if (el.hasAttribute('aria-label') && offer.title) {
          el.setAttribute('aria-label', decodeEntities(offer.title));
        }
      }
      return;
    }
    if (key === 'atc') {
      var showAtc = offer.kind !== 'vip' && offer.variantId;
      setHidden(el, !showAtc);
      if (showAtc) {
        el.setAttribute('data-variant-id', String(offer.variantId));
        if (el.tagName !== 'INPUT' && offer.atc) setText(el, offer.atc);
      }
      return;
    }
    if (key === 'pack-only') {
      setHidden(el, offer.kind === 'vip');
      return;
    }
    if (key === 'vip-only') {
      setHidden(el, offer.kind !== 'vip');
      return;
    }
    if (key === 'products') {
      var items = offer.products || [];
      el.innerHTML = items
        .map(function (text) {
          return '<li>' + String(text).replace(/</g, '&lt;') + '</li>';
        })
        .join('');
      return;
    }
    if (key === 'compare_at') {
      el.textContent = decodeEntities(offer.compare_at || '');
      setHidden(el, !offer.compare_at);
      return;
    }

    var value = offer[key];
    if (value == null) return;
    if (HTML_KEYS[key]) {
      el.innerHTML = value;
      return;
    }
    el.textContent = decodeEntities(value);
  }

  function applyOffer(offer, slotEndIso) {
    if (!offer) return;
    document.querySelectorAll('[data-lsp-rotating]').forEach(function (el) {
      applyField(el, el.getAttribute('data-lsp-rotating'), offer, slotEndIso);
    });
    document.documentElement.setAttribute('data-lsp-rotating-id', offer.id);
    document.documentElement.setAttribute('data-lsp-rotating-kind', offer.kind);
    document.querySelectorAll('[data-lsp-hero-slide].lsp-home-hero-carousel__slide--vip').forEach(function (slide) {
      slide.setAttribute('data-badge-label', offer.cta_short || offer.title || '');
    });
  }

  function addToCart(variantId, button) {
    if (!variantId) return;
    var config = window.LSPRotatingOffer && window.LSPRotatingOffer.config;
    var addUrl = (config && config.cartAddUrl) || (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (addUrl.indexOf('.js') === -1) addUrl += '.js';
    var cartUrl = (config && config.cartUrl) || (window.routes && window.routes.cart_url) || '/cart';
    var original = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = '…';
    }

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add');
        window.location.href = cartUrl;
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      });
  }

  var atcBound = false;

  function bindAtc() {
    if (atcBound) return;
    atcBound = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lsp-rotating="atc"]');
      if (!button) return;
      event.preventDefault();
      addToCart(button.getAttribute('data-variant-id'), button);
    });
  }

  function scheduleNextSlot(slotEndMs, config) {
    var delay = Math.min(Math.max(slotEndMs - Date.now() + 250, 1000), 2147483647);
    window.setTimeout(function () {
      var next = computeSlot(config);
      if (!next.offer) return;
      applyOffer(next.offer, next.slotEndIso);
      window.LSPRotatingOffer.current = next;
      scheduleNextSlot(next.slotEndMs, config);
    }, delay);
  }

  function init() {
    var config = readConfig();
    if (!config || config.enabled === false || !config.offers || !config.offers.length) return;

    var state = computeSlot(config);
    if (!state.offer) return;

    applyOffer(state.offer, state.slotEndIso);
    bindAtc();
    scheduleNextSlot(state.slotEndMs, config);

    window.LSPRotatingOffer = {
      config: config,
      current: state,
      computeSlot: function () {
        return computeSlot(config);
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
